import {T} from 'ramda';

// type _ModuleButton = {
//   checkVisible = AppContext -> Boolean
//   priority = Number?
//   text = String
//   location: String,
//   ...
// }
// Currently supported location values: 'HomePage', 'StoryList', 'Nav', 'SiteTree', 'Shows'

// ModuleButton :: Object -> _ModuleButton
const ModuleButton = ({
  checkVisible = T,
  priority = 100,
  text,
  location,
  ...props
}) => ({
  checkVisible,
  priority,
  text,
  location,
  ...props,
});

export default ModuleButton;
